import * as t from "io-ts";
import { UUID as uuidCodec } from "io-ts-types/UUID";

export const sharedDonationCodec = t.type({
  userId: uuidCodec,
  nonprofitSlug: t.string,
  donationChargeId: uuidCodec,
});
export type SharedDonationData = t.TypeOf<typeof sharedDonationCodec>;

export const initialReferringPageCodec = t.type({
  referrer: t.string,
});

// Set server-side (httpOnly) from the real `Referer` request header, scoped
// to requests carrying a partner webhook_token — see PARTNER_WEBHOOK_REFERRER.
export const partnerWebhookReferrerCodec = t.type({
  referrer: t.string,
});

export const adminReferralCodec = t.type({
  referral: t.string,
});

export const landingPageCodec = t.type({
  landingPage: t.string,
});

export const signupInviteDataCodec = t.intersection([
  t.type({ inviteCode: t.string }),
  t.partial({ invitedByUserId: uuidCodec }),
]);
export type InviteData = t.TypeOf<typeof signupInviteDataCodec>;
